import { useCallback } from "react";
import { IFillableFormRequest } from "../types";

export const useGetFormData = () => {
  const getFormData = useCallback((entry: any): IFillableFormRequest => {
    const request: any = {
      ...entry,
    };

    if (entry.file && entry.file.length > 0) {
      request.fileId = entry.file[0].response;

      delete request.file;
    }

    return request;
  }, []);

  return { getFormData };
};
